// DevDiffView.js — Diff texte brut (pas de Monaco)

import React, { memo } from 'react';
import './devCockpit.css';

function DevDiffView({ path, diff, loading }) {
    if (loading) {
        return <div className="dev-git-diff__empty">Chargement diff…</div>;
    }

    if (!path) {
        return (
            <div className="dev-git-diff__empty">
                Sélectionnez un fichier modifié pour voir le diff
            </div>
        );
    }

    if (!diff) {
        return (
            <div className="dev-git-diff__empty">
                Aucune différence — cliquez « Actualiser diff »
            </div>
        );
    }

    return (
        <div className="dev-git-diff">
            <pre className="dev-git-diff__text">{diff}</pre>
        </div>
    );
}

export default memo(DevDiffView);
